export { Notice } from './Notice';

export type { NoticeProps } from './Notice';
